'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosAnalytics = function IoIosAnalytics(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5 0 1-0.1 2-0.2 2.9-0.1 0.5-0.2 0.9-0.3 1.3-1.8 7.7-8.8 13.3-17 13.3-9.5 0-17.3-7.7-17.5-17.1v-0.4c0-0.7 0.1-1.3 0.2-2 1-8.7 8.3-15.5 17.3-15.5z m16.2 19.4c0.1-0.6 0.1-1.3 0.1-1.9 0-2.2-0.4-4.3-1.3-6.3-0.8-2-2-3.7-3.5-5.2s-3.2-2.7-5.2-3.5c-2-0.9-4.1-1.2-6.3-1.2s-4.3 0.3-6.3 1.2c-2 0.8-3.7 2-5.2 3.5s-2.7 3.2-3.5 5.2c-0.9 2-1.2 4.1-1.2 6.3 1 1.6 2.2 2.7 2.2 2.7h0.1v0c0.1 0.1 1.2 1.3 2.8 1.1 0.9-0.2 2.1-2.1 3-3.3 0.3-0.5 0.7-1 0.9-1.3 1.3-1.6 2.7-1.8 3.5-1.6 1.9 0.2 3.5 2.1 4.3 3.9 0.5 1.4 1.4 2.2 2.5 2.3 1.1 0 2.4-0.8 3.3-2.3 0.1-0.2 0.2-0.3 0.3-0.6 0.7-1.3 1.9-3.4 4.1-3.4 2.4 0 4 2.7 4.1 2.8 0.3 0.3 0.7 0.9 1.3 1.6z' })
        )
    );
};

exports.default = IoIosAnalytics;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-analytics.js
// module id = 2091
// module chunks = 0